import React from "react";
import { Route } from "react-router-dom";
import { LANGS } from "./data";
import BlogIndex from "../components/blog/BlogIndex";
import BlogPost from "../components/blog/BlogPost";
import BlogTag from "../components/blog/BlogTag";
import BlogAuthor from "../components/blog/BlogAuthor";

/**
 * Trasy bloga generowane z manifestu (segmenty są zlokalizowane: /pl/blog/strona/2,
 * /de/blog/seite/2). Segmenty statyczne mają w React Routerze wyższy priorytet niż
 * `:slug`, więc kolejność w tablicy nie ma znaczenia — mimo to trzymamy ją od
 * najbardziej szczegółowej.
 */
export default function blogRoutes() {
  return Object.values(LANGS).flatMap((cfg) => {
    const { lang, segments } = cfg;
    const base = `/${lang}/blog`;
    return [
      <Route key={`${lang}-index`} path={base} element={<BlogIndex lang={lang} />} />,
      <Route
        key={`${lang}-page`}
        path={`${base}/${segments.page}/:page`}
        element={<BlogIndex lang={lang} />}
      />,
      <Route
        key={`${lang}-tag`}
        path={`${base}/${segments.tag}/:tag`}
        element={<BlogTag lang={lang} />}
      />,
      <Route
        key={`${lang}-author`}
        path={`${base}/${segments.author}/:author`}
        element={<BlogAuthor lang={lang} />}
      />,
      <Route key={`${lang}-post`} path={`${base}/:slug`} element={<BlogPost lang={lang} />} />,
    ];
  });
}
